module.exports = "/_next/static/images/PersonalizationGraphData@2x-f19c89213dfd4a8793ab94d41a01fedd.webp";